const GAME_REASON_CTA = {
    LOBBY: 0,
    CASHIER_DEPOSIT: 5,
    LOBBY_FROM_GAME_LOAD: 6,
    HISTORY: 7,
    SELF_TEST_SWEDEN: 10,
    OPEN_LIMITS_SWEDEN: 11,
    SELF_EXCLUSION_SWEDEN: 12,
    RESPONSIBLE_GAMING: 13,
};
const GAME_POST_MESSAGES = {
    GOTO_LOBBY: 'GOTO_LOBBY',
    CASHIER: 'CASHIER',
    OPEN_GAME_HISTORY: 'OPEN_GAME_HISTORY'
};

export {GAME_REASON_CTA, GAME_POST_MESSAGES};